import PropTypes from "prop-types";
import { handleEvent } from "@gx1/gx-npm-lib";
import { Banner, bannerTypes } from "./banner";
import { Snackbar } from "./snackbar";

const defaultErrorMessage = "Oops... something went wrong. Please try again.";

const propTypes = {
  anchorVertical: PropTypes.string,
  anchorHorizontal: PropTypes.string,
  autoHideDuration: PropTypes.number,
  buttonText: PropTypes.string,
  handleButtonClick: PropTypes.func,
  isDefaultErrorMessage: PropTypes.bool,
  isOpen: PropTypes.bool,
  isTimeoutAllowed: PropTypes.bool,
  keyName: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  snackbarClasses: PropTypes.object,
  pointerActionCursor: PropTypes.bool,
  setIsOpen: PropTypes.func,
  transitionDuration: PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number,
  }),
  type: PropTypes.string,
};

/**
 * @deprecated DO NOT USE, DO NOT UPDATE
 * @todo REPLACE EXISTING REFERENCES WITH GRAVITY: "Banner" (for error alerts) or "Snackbar" (success alerts) components
 */
const SnackbarBanner = ({
  anchorVertical = "top",
  anchorHorizontal = "center",
  autoHideDuration = 5000,
  buttonText = "",
  handleButtonClick = (_e) => { },
  isDefaultErrorMessage = false,
  isOpen = false,
  isTimeoutAllowed = true,
  keyName = "",
  message = "",
  pointerActionCursor = false,
  setIsOpen = (_e) => { },
  snackbarClasses = {},
  transitionDuration = {
    enter: 300,
    exit: 300,
  },
  type = bannerTypes.error,
}) => {
  if (type === bannerTypes.success || type === bannerTypes.miniSuccess) {
    anchorVertical = "bottom";
    anchorHorizontal = "left";
  }

  return (
    <Snackbar
      anchorVertical={anchorVertical}
      anchorHorizontal={anchorHorizontal}
      autoHideDuration={autoHideDuration}
      isOpen={isOpen}
      isTimeoutAllowed={isTimeoutAllowed}
      muiClasses={snackbarClasses}
      uniquKey={keyName}
      setIsOpen={(e) => handleEvent(setIsOpen, e)}
      transitionDuration={transitionDuration}
      type={type}
    >
      <Banner
        buttonText={buttonText}
        handleButtonClick={handleButtonClick}
        handleCloseClick={() => handleEvent(setIsOpen, false)}
        message={isDefaultErrorMessage ? defaultErrorMessage : message}
        pointerActionCursor={pointerActionCursor}
        type={type}
      />
    </Snackbar>
  );
};

SnackbarBanner.propTypes = propTypes;
export default SnackbarBanner;
